module.exports = __webpack_public_path__ + "img/pipe-tutorial01.ce62185a.png";